import { usePortalLivePinsQuery } from "@dashboard/graphql";
import { Box, Text } from "@saleor/macaw-ui-next";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { portalLabels as l } from "../labels";
import { portalMessages as m } from "../messages";

/** Live rotating PIN(s), large — e.g. on a screen at the entrance. */
export const LivePins = ({ large }: { large?: boolean }) => {
  const intl = useIntl();
  const { data, refetch } = usePortalLivePinsQuery({ fetchPolicy: "network-only" });
  const [now, setNow] = useState(Date.now());
  const [fetchedAt, setFetchedAt] = useState(Date.now());

  useEffect(() => {
    setFetchedAt(Date.now());
  }, [data]);
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);

    return () => window.clearInterval(timer);
  }, []);

  const pins = data?.entryPins ?? [];
  const elapsed = Math.floor((now - fetchedAt) / 1000);
  const left = Math.min(...pins.map(p => p.secondsLeft), 999) - elapsed;

  useEffect(() => {
    if (pins.length && left <= 0) {
      refetch();
    }
  }, [left, pins.length, refetch]);

  return (
    <Box display="grid" gap={3} __gridTemplateColumns="repeat(auto-fit, minmax(260px, 1fr))">
      {pins.map(entry => (
        <Box
          key={entry.workSiteId ?? "none"}
          padding={4}
          borderRadius={4}
          borderWidth={1}
          borderStyle="solid"
          borderColor="default1"
          textAlign="center"
        >
          <Text size={3} color="default2">
            {entry.workSiteId ? entry.workSiteName : intl.formatMessage(l.noSite)}
          </Text>
          <Box paddingY={2}>
            <Text
              fontWeight="bold"
              __fontSize={large ? "96px" : "40px"}
              __lineHeight={large ? "110px" : "48px"}
              __letterSpacing="0.15em"
              __fontFamily="monospace"
            >
              {entry.pin}
            </Text>
          </Box>
          <Text size={2} color="default2">
            {intl.formatMessage(m.pinChangesIn, {
              seconds: Math.max(0, entry.secondsLeft - elapsed),
            })}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export const PinScreen = () => (
  <Box padding={6}>
    <LivePins large />
  </Box>
);
